import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Image, Modal } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import ReCAPTCHA from "react-google-recaptcha";
import Bullet from '../../Images/Bullet.svg';
import BulletCheck from '../../Images/Bullet-check.svg';
import Backend from '../../Backend';
import NavbarComponent from '../Navbar';
import { store } from 'react-notifications-component';
import Connection from '../../Calls';
import ModeColorComponent from '../../ColorMode';
import LogoWirebit from '../../Images/Logos/LogoAzul.png';
import HtmlModal from '../Landing/pages/components/footer/htmlModal';
import termsHTML from '../../Components/Landing/pages/components/footer/htmls/termsContent';
import SelectCountry from '../Select/SelectCountries';
import countries from '../Select/countryOptions';
import es from '../../translate/es';
import en from '../../translate/en';
import './index.css';

var countryForgot; //send country for signup
var countryConfirm; //Resend confirmation

class SignupIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      country: '',
      lastName: '',
      email: '',
      firstName: '',
      password: '',
      confirmPassword: '',
      key: '',
      reCaptcha: '',
      showload: false,
      // -------------- //
      validatePass8: false,
      validatePassMayus: false,
      validatePassMinus: false,
      validatePassDigit: false,
      validatePassEspecial: false,
      validatePassSame: false,
      // -------------- //
      showModal: false,
      showloadConfirm: false,
      countryConfirm: '',
      emailConfirm: '',
      aceptConfirm:false,
      text: en,
      showTerms: false
    }
  }

  componentWillMount() {
    this.bQk7VZx7();
    this.setState({country: countryConfirm})
    if(this.props.lan === 'es'){
      this.setState({text:es})
    } else{
      this.setState({text:en})
    }
  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  // onSelectFlagConfirm(countryCode) {
  //   var countrieSelect = Countries[countryCode];
  //   countryConfirm = countrieSelect;
  // }

  // onSelectFlag(countryCode) {
  //   var countrieSelect = Countries[countryCode];
  //   countryForgot = countrieSelect;
  // }

  onSelectCountryForgot(countryCode){
    var countrieSelect = countryCode.label;
    countryConfirm = countrieSelect
  }

  onSelectCountry(countryCode){
    var countrieSelect = countryCode.label;
    countryForgot = countrieSelect
  }

  reenviarConfirmation() {
    const self = this;
    self.setState({ showloadConfirm: true });
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.emailConfirm) !== false) {
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
      let whiskas = Connection.RThzHrsb(self.state.emailConfirm)
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;

      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
        Backend.ResendConfirmation(self.state.emailConfirm, countryConfirm, response.payload.r03, self.state.reCaptcha, response => {
          if (response.status.code === "0") {
            store.addNotification({
              title: "Success!",
              message: response.payload.message,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 3000,
                onScreen: true
              }
            });
            self.setState({ countryConfirm: '', emailConfirm: '', key: '', reCaptcha: '', showloadConfirm: false });
            setTimeout(function () { self.props.data.history.push("/") }, 2000);
          } else {
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 3000,
                onScreen: true
              }
            });
            self.setState({ showloadConfirm: false });
          }
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Email is bad formmated",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      self.setState({ showloadConfirm: false });
    }
  }

  validatePassword() {
    const self = this;

    if (self.state.password.length >= 8) {
      self.setState({ validatePass8: true });
    } else {
      self.setState({ validatePass8: false });
    }

    if (/(?:.*[A-Z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMayus: true });
    } else {
      self.setState({ validatePassMayus: false });
    }

    if (/(?:.*[a-z]){1}/.test(this.state.password)) {
      self.setState({ validatePassMinus: true });
    } else {
      self.setState({ validatePassMinus: false });
    }

    if (/(?:.*\d){1}/.test(this.state.password)) {
      self.setState({ validatePassDigit: true });
    } else {
      self.setState({ validatePassDigit: false });
    }

    if (/[`~!@#$%^&*()_°¬|+\-=?;:'",.<>\]\\]/gi.test(this.state.password)) {
      self.setState({ validatePassEspecial: true });
    } else {
      self.setState({ validatePassEspecial: false });
    }

    if (this.state.password === this.state.confirmPassword && this.state.password !== "" && this.state.confirmPassword !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }

  }

  validateConfirmPassword() {
    const self = this;
    if (this.state.confirmPassword === this.state.password && this.state.confirmPassword !== "" && this.state.password !== "") {
      self.setState({ validatePassSame: true });
    } else {
      self.setState({ validatePassSame: false });
    }
  }

  sendData() {
    const self = this;
    const { text } = this.state

    if(!this.state.aceptConfirm){
      store.addNotification({
        title: "Error!",
        message: text.Register.messageError.errorTerms,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      return
    }

    self.setState({ showload: true, buttonLocked: true });
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.email) !== false) {
      if (this.state.reCaptcha !== "") {
        // console.log(countryForgot, this.state.lastName, this.state.email, this.state.firstName, this.state.password, this.state.confirmPassword);
        if (countryForgot !== "" && this.state.lastName !== "" && this.state.email !== "" && this.state.firstName !== "" && this.state.password !== "" && this.state.confirmPassword !== "") {
          if (this.state.password === this.state.confirmPassword) {
            let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
            let whiskas = Connection.RThzHrsb(self.state.confirmPassword)
            navigator.geolocation.getCurrentPosition((success, error, options) => {
              latitude = success.coords.latitude;
              longitude = success.coords.longitude
            });
            result = latitude + longitude;
            Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
              Backend.Register(response.payload.r03, self.state.email, self.state.firstName, self.state.lastName, countryForgot, self.state.reCaptcha, response => {
                if (response.status.code === "0") {
                  store.addNotification({
                    title: "Success!",
                    message: response.payload.message,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
                  self.setState({ country: '', lastName: '', email: '', firstName: '', password: '', confirmPassword: '', key: '', reCaptcha: '', showload: false, validatePass8: false, validatePassMayus: false, validatePassMinus: false, validatePassDigit: false, validatePassEspecial: false, validatePassSame: false });
                  setTimeout(function () { self.props.data.history.push("/") }, 2000);
                } else {
                  store.addNotification({
                    title: "Error!",
                    message: response.status.description,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 3000,
                      onScreen: true
                    }
                  });
                  self.setState({ showload: false, buttonLocked: true });
                }
              });
            });
          } else {
            store.addNotification({
              title: "Error!",
              message: text.Register.messageError.errorPwd,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 3000,
                onScreen: true
              }
            });
            self.setState({ showload: false, buttonLocked: true });
          }
        } else {
          store.addNotification({
            title: "Error!",
            message: text.Register.messageError.errorEmpty,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true
            }
          });
          self.setState({ showload: false, buttonLocked: true });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: text.Register.messageError.errorCaptcha,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        self.setState({ showload: false, buttonLocked: true });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: text.Register.messageError.errorEmail,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true
        }
      });
      self.setState({ showload: false, buttonLocked: true });
    }
  }

  handleCheck(val) {
    const self = this;
    self.setState({ aceptConfirm: val.target.checked });
  }

  // redirecTerms() {
  //   var win = window.open('https://wirebit.com/terms', '_blank');
  //   win.focus();
  // }

  redirectLanding(){
    this.props.data.history.push("/");
  }

  render() {
    return (
      <div className='newSignupBG'>
        {/* <NavbarComponent data={this.props} selected="register" /> */}
        <div className="wrapper-background">
          <div className="wrapper-signup">
            <Container>
            <div className='d-flex justify-content-center' style={{marginBottom: '15px'}}>
                <Image onClick={() => { this.redirectLanding() }} src={LogoWirebit} style={{ width: 150, cursor: 'pointer' }} />
              </div>
              <Row>
                <Col md={12}>
                  <div className="border-title-separator-container">
                    <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                      <div className='d-flex justify-content-center'>
                        <span className='title-login'>{this.state.text.Register.title}</span>
                      </div>
                    </div>
                  </div>
                  <div className="align-text-signup">
                    <span className="regular-text">{this.state.text.Register.text_already}</span>
                    <a className="link-account" onClick={() => this.props.data.history.push("/login")}>{this.state.text.Register.link_logIn}</a>
                  </div>
                </Col>
                <Col md={12}>
                  <div>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_mail}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                type="email"
                                className="input-signup"
                                value={this.state.email}
                                onChange={(email) => { this.setState({ email: email.target.value }) }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_name}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                type="text"
                                className="input-signup"
                                value={this.state.firstName}
                                onChange={(firstName) => { this.setState({ firstName: firstName.target.value }) }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_lastname}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                type="text"
                                className="input-signup"
                                value={this.state.lastName}
                                onChange={(lastName) => { this.setState({ lastName: lastName.target.value }) }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                      <Form.Group>
                        <Form.Label className="label-forgot">{this.state.text.Register.L_country}</Form.Label>
                        <Col sm="12">
                          <SelectCountry
                            options={countries}
                            isSearchable={true}
                            value={this.state.country}
                            onChange={this.onSelectCountry}
                          />
                        </Col>
                      </Form.Group>
                        {/* <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_country}</Form.Label>
                          <center>
                            <Col>
                              <ReactFlagsSelect
                                className="input-signup form-control"
                                placeholder=''
                                searchable={true}
                                searchPlaceholder="Search for a country"
                                value={this.state.country}
                                onSelect={this.onSelectFlag}
                              />
                            </Col>
                          </center>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_password}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                type="password"
                                className="input-signup"
                                value={this.state.password}
                                onChange={(password) => { this.setState({ password: password.target.value }) }}
                                onKeyUp={() => { this.validatePassword() }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="label-font-input">{this.state.text.Register.L_cPassword}</Form.Label>
                          <center>
                            <Col>
                              <Form.Control
                                className="input-signup"
                                type="password"
                                value={this.state.confirmPassword}
                                onChange={(confirmPassword) => { this.setState({ confirmPassword: confirmPassword.target.value }) }}
                                onKeyUp={() => { this.validateConfirmPassword() }}
                              />
                            </Col>
                          </center>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group>
                      <Col md={12}>
                        <div className="container-messages-signup">
                          <p className={!this.state.validatePass8 ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePass8 ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req1}.
                          </p>
                          <p className={!this.state.validatePassMayus ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMayus ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req2}.
                          </p>
                          <p className={!this.state.validatePassMinus ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassMinus ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req3}.
                          </p>
                          <p className={!this.state.validatePassDigit ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassDigit ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req4}.
                          </p>
                          <p className={!this.state.validatePassEspecial ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassEspecial ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req5}.
                          </p>
                          <p className={!this.state.validatePassSame ? "text-validate-pwd" : "success-validate-pwd"}>
                            <Image className="icono-check-text-password" src={!this.state.validatePassSame ? Bullet : BulletCheck} />
                            {this.state.text.General.PassRequirements.req6}.
                          </p>
                        </div>
                      </Col>
                    </Form.Group>
                    <Form.Group>
                      <Col className='check-sign'>
                        <Form.Check onChange={(e) => { this.handleCheck(e) }} inline label={this.state.text.Register.agree1} type={'checkbox'} id={"inline-'checkbox"} />
                        <span style={{marginLeft:5}} className='terms-link' onClick={()=>this.setState({showTerms: true})}>{this.state.text.Register.agree2}</span>
                      </Col>
                    </Form.Group>
                    <div>
                      <center style={{ marginBottom: 0 }}>
                        {
                          this.state.vertice &&
                          <ReCAPTCHA
                            theme="light"
                            key="1"
                            sitekey={this.state.vertice}
                            onChange={this.handleChange.bind(this)}
                          />
                        }
                      </center>
                    </div>
                    <div>
                      <div style={{ marginTop: 30, textAlign: "center" }}>
                        <Button className="signup-button" style={{width: '96%'}} variant="primary" onClick={() => { this.sendData() }} disabled={this.state.showload}>
                          {
                            (this.state.showload)
                              ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                              : <span className="label-btn-login">{this.state.text.Register.btn}</span>
                          }
                        </Button>
                      </div>
                      <div style={{ marginTop: 0, textAlign: "center" }}>
                        <Button className="resend-email" variant="link" onClick={() => { this.setState({ showModal: true }); }}>{this.state.text.Register.link}</Button>
                      </div>
                      <div className="resend-email" style={{ marginTop: 0, textAlign: "center" }}>
                        {this.state.text.Register.spam_warning}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <HtmlModal
          show={this.state.showTerms}
          close={()=>this.setState({showTerms:false})}
          html={termsHTML}
        />
        {this.MethodModalResendEmailConfirmation()}
        <ModeColorComponent onToggleSwitchChange={this.props.onToggleSwitchChange} checked={this.props.checked} />
      </div>
    );
  }

  MethodModalResendEmailConfirmation() {
    return (
      <Modal className="modal-signup-resend-email" aria-labelledby="contained-modal-title-vcenter" centered show={this.state.showModal} onHide={() => { this.handleClose() }}>
        <Modal.Body className='modal-resend-email'>
          <div className="border-title-separator-container">
            <div className="border-title-separator-container-left" style={{ width: "100%" }}>
              <p className='title-login'>{this.state.text.Register.confirmation.link}</p>
            </div>
          </div>
          <div>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="label-font-input">{this.state.text.Register.confirmation.L_mail}</Form.Label>
                  <Col>
                    <Form.Control
                      type="email"
                      // placeholder="example@mail.com"
                      className="input-signup"
                      value={this.state.emailConfirm}
                      onChange={(emailConfirm) => { this.setState({ emailConfirm: emailConfirm.target.value }) }}
                    />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="label-font-input">{this.state.text.Register.confirmation.L_country}</Form.Label>
                  <Col>
                    <SelectCountry
                      options={countries}
                      isSearchable={true}
                      value={this.state.country}
                      onChange={this.onSelectCountryForgot}
                    />
                    {/* <ReactFlagsSelect
                      className="input-signup form-control"
                      placeholder=""
                      searchable={true}
                      searchPlaceholder="Search for a country"
                      value={this.state.country}                      
                      onSelect={this.onSelectFlagConfirm}
                    /> */}
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <div>
              <center style={{ marginBottom: 0 }}>
                {
                  (this.state.vertice) &&
                  <ReCAPTCHA
                    theme="light"
                    key="1"
                    sitekey={this.state.vertice}
                    onChange={this.handleChange.bind(this)}
                  />
                }
              </center>
            </div>
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <Button className="resend-email-btn" variant="primary" onClick={() => { this.reenviarConfirmation() }} disabled={this.state.showloadConfirm}>
                {
                  (this.state.showloadConfirm)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showloadConfirm} />
                    : "Send Email"
                }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
} export default SignupIndex;
